module.exports = __webpack_public_path__ + "media/luxury-2026/lake-architecture-drone-960-546edfeb.jpg";